"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_router_1 = require("react-router");
var constants_1 = require("../components/shared/constants");
function removeSlugFromId(props) {
    var cleaned = tslib_1.__assign(tslib_1.__assign({}, props.routeParams), { id: props.routeParams.id.split('-')[0] });
    return tslib_1.__assign(tslib_1.__assign({}, props), { routeParams: cleaned });
}
function getItemShow(location, cb) {
    require.ensure([], function (require) {
        var Component = require('../components/discovery/item_show_pivot').default;
        cb(null, function (props) {
            return React.createElement(Component, tslib_1.__assign({}, removeSlugFromId(props)));
        });
    }, 'item-show');
}
exports.ItemShowRoute = (React.createElement(react_router_1.Route, { key: constants_1.ITEM_SHOW_ROUTE_PATH, path: constants_1.ITEM_SHOW_ROUTE_PATH, getComponent: getItemShow }));
exports.Item2ShowRoute = (React.createElement(react_router_1.Route, { key: constants_1.ITEM2_SHOW_ROUTE_PATH, path: constants_1.ITEM2_SHOW_ROUTE_PATH, props: { clientSide: true }, getComponent: function (location, cb) {
        require.ensure([], function (require) {
            var Component = require('../components/item2_layout').default;
            cb(null, function (props) {
                return React.createElement(Component, tslib_1.__assign({}, removeSlugFromId(props)));
            });
        }, 'item2-show');
    } }));
exports.ItemPreviewRoute = (React.createElement(react_router_1.Route, { key: constants_1.ITEM_PREVIEW_PATH, path: constants_1.ITEM_PREVIEW_PATH, getComponent: getItemShow }));
exports.ItemPreviewConfirmRoute = (React.createElement(react_router_1.Route, { key: constants_1.ITEM_PREVIEW_CONFIRM_PATH, path: constants_1.ITEM_PREVIEW_CONFIRM_PATH, getComponent: getItemShow }));
//# sourceMappingURL=item_show.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/routes/item_show.js
// module id = RoQb
// module chunks = 20 21